import React, { FC } from 'react';
import { Icon } from '@sravni/react-design-system';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { Edit } from '@sravni/react-icons';
import { UseFormReturn } from 'react-hook-form';
import { WPViews } from '../constants';
import { needed as fieldNeeded } from '../dependencies';
import { FORM_FIELDS } from '../../../../../constants';
import { Col } from '../../../../landing.common';
import { Row } from '../../common';
import {
    AreaOfEmploymentField,
    EmployerInnField,
    EmployerTypeField,
    WorkAddressField,
} from '../../../../../helpers/form.new/fields/work';
import styles from './styles.module.scss';

interface WorkPlaceFieldsProps {
    form: UseFormReturn;
    workPlaceView: WPViews;
    onOpenEditor: () => void;
    onFocus: React.FocusEventHandler<HTMLInputElement>;
}

export const WorkPlaceFields: FC<WorkPlaceFieldsProps> = (props) => {
    const { form, workPlaceView, onOpenEditor, onFocus } = props;
    const {
        control,
        formState: { errors, dirtyFields: _ },
        getValues,
        watch,
    } = form;

    const [employmentType] = watch([FORM_FIELDS.EMPLOYMENT_TYPE]);

    const isWorkPlaceValid = [
        FORM_FIELDS.EMPLOYER_TYPE,
        FORM_FIELDS.AREA_OF_EMPLOYMENT,
        FORM_FIELDS.EMPLOYER_INN,
        FORM_FIELDS.WORK_ADDRESS,
    ].every((fieldName) => !errors[fieldName]);

    const isShowMinimized =
        workPlaceView === WPViews.wpShort &&
        fieldNeeded(FORM_FIELDS.ORGANIZATION_NAME, employmentType) &&
        isWorkPlaceValid;

    const isShowAllFields = workPlaceView === WPViews.wpVisible || !isWorkPlaceValid;

    if (isShowMinimized) {
        return (
            <Row onFocus={onFocus}>
                <Col>
                    <div data-qa={'Alert'} className={styles['work-place__summary']}>
                        <Text size={14}>
                            {[
                                getValues(FORM_FIELDS.ORGANIZATION_NAME),
                                `ИНН ${getValues(FORM_FIELDS.EMPLOYER_INN)}`,
                                getValues(FORM_FIELDS.WORK_ADDRESS),
                            ].join(', ')}
                        </Text>
                        <button type="button" className={styles['edit-button']} onClick={onOpenEditor}>
                            <Text size={14} className={styles['edit-button__text']}>
                                Редактировать
                            </Text>
                            <Icon size={16} icon={<Edit />} color="blue" />
                        </button>
                    </div>
                </Col>
            </Row>
        );
    }

    if (isShowAllFields) {
        return (
            <>
                <Row onFocus={onFocus}>
                    {fieldNeeded(FORM_FIELDS.EMPLOYER_TYPE, employmentType) && (
                        <Col md-4>
                            <EmployerTypeField control={control} error={errors[FORM_FIELDS.EMPLOYER_TYPE]?.message} />
                        </Col>
                    )}
                    {fieldNeeded(FORM_FIELDS.AREA_OF_EMPLOYMENT, employmentType) && (
                        <Col md-4>
                            <AreaOfEmploymentField
                                control={control}
                                error={errors[FORM_FIELDS.AREA_OF_EMPLOYMENT]?.message}
                            />
                        </Col>
                    )}
                    {fieldNeeded(FORM_FIELDS.EMPLOYER_INN, employmentType) && (
                        <Col md-4>
                            <EmployerInnField control={control} error={errors[FORM_FIELDS.EMPLOYER_INN]?.message} />
                        </Col>
                    )}
                </Row>

                {fieldNeeded(FORM_FIELDS.WORK_ADDRESS, employmentType) && (
                    <Row onFocus={onFocus}>
                        <Col md-8>
                            <WorkAddressField control={control} error={errors[FORM_FIELDS.WORK_ADDRESS]?.message} />
                        </Col>
                    </Row>
                )}
            </>
        );
    }

    return null;
};
